<template>
  <div>
    <v-container>
      <h3>Information regarding the Data Download</h3>
      <p>
        The individual registration data can be downloaded by clicking the download icon on the
        dashboard
      </p>
      <img src="/images/gn_dl_tutorial.png" width="900" alt="" />
      <p>Or by going inside each registration file details</p>
      <img src="/images/gn_dl_2.png" width="900" alt="" />
      <br />

      <!-- <v-checkbox
        v-model="isTermsAgreed"
        :label="'I understand the above information and I am ready to download'"
      >
      </v-checkbox> -->
      <div v-if="this.userRoleId != 8">
        <p>This page is for bulk downloading of the registration files</p>
        <v-btn primary class="primary ma-2 px-6" v-on:click="downloadRegistrationAllCSV"
          >Download Registration Data (CSV)
        </v-btn>
        <!-- <a href="http://127.0.0.1:8082/api/registration/download-reg-all">Download csv</a> -->
        <br /><br /><br />
        <h3>Bulk Download</h3>
        <p>
          <i
            >Each registration file size is very large, so whole system data cannot be downloaded in
            one bulk due to high failure rate. So download data in small bulks using the form below.
            <br />
            Input the registration id start and end. For example: To download from registration id 1
            to 20, input 1 in start and 20 in end input. For details about registration id, download
            the registration list excel sheet from above button
            <strong>Download Registration Data (CSV)</strong></i
          >
          <br />
          You can bulk download 100 registration files at a time
        </p>
        <v-form v-model="formValid">
          <v-row>
            <v-col>
              <v-text-field
                v-model="registrationDateStart"
                ref="registrationDateStart"
                label="Start Id"
                outlined
                :rules="[
                  required('Start Id'),
                  positiveIntegerRule('Start Id'),
                  lessThanOtherField('Start Id', () => registrationDateEnd),
                  differenceLessThan(100, 'Start Id', 'End Id'),
                ]"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="registrationDateEnd"
                label="End Id"
                outlined
                :rules="[
                  required('End Id'),
                  positiveIntegerRule('End Id'),
                  differenceLessThan(100, 'Start Id', 'End Id'),
                ]"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-btn
            primary
            class="primary ma-2 px-6"
            v-on:click="bulkDownload(registrationDateStart, registrationDateEnd)"
            :disabled="!formValid"
            >Download</v-btn
          >
        </v-form>
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "DataDownloadPage",
  data() {
    return {
      formValid: false,
      userRoleId: localStorage.getItem("auth_user_role_id"),
      userToken: localStorage.getItem("token"),
      isTermsAgreed: null,
      registrationDateStart: null,
      registrationDateEnd: null,
      registrationsCount: null,
      required(propertyType) {
        return (v) => !!v || `${propertyType} is required`;
      },
      positiveIntegerRule(fieldName) {
        return (v) => {
          const number = Number(v);
          return (
            (Number.isInteger(number) && number >= 1 && number <= this.registrationsCount) ||
            `${fieldName} must be an integer between 1 and ${this.registrationsCount}`
          );
        };
      },
      lessThanOtherField(fieldName, otherFieldGetter) {
        return (v) => {
          const current = Number(v);
          const other = Number(otherFieldGetter());

          if (!Number.isInteger(current) || !Number.isInteger(other)) return true;

          return current < other || `${fieldName} must be less than End Id`;
        };
      },
      differenceLessThan(maxDiff, labelA, labelB) {
        return () => {
          const a = Number(this.registrationDateStart);
          const b = Number(this.registrationDateEnd);
          if (isNaN(a) || isNaN(b)) return true; // Skip if either is empty
          return (
            Math.abs(a - b) < maxDiff ||
            `The difference between ${labelA} and ${labelB} must be less than ${maxDiff}`
          );
        };
      },
    };
  },
  watch: {
    registrationDateEnd(newVal) {
      // Re-validate start id when end id changes
      this.$nextTick(() => {
        if (this.$refs.registrationDateStart) {
          this.$refs.registrationDateStart.validate();
        }
      });
    },
  },
  created() {
    this.getRegistrationsCount();
  },
  methods: {
    // download(reg_id) {
    //   const url = `/api/registration/${reg_id}/download-data`;
    //   // console.log("user token "+ this.userToken );
    //   this.$axios
    //     .get(url, {
    //       responseType: "blob",
    //     })
    //     .then((response) => {
    //       // console.log("response headers " + JSON.stringify(response.headers));
    //       let filename = "download.zip"; // fallback
    //       const disposition = response.headers["content-disposition"];
    //       // console.log("dispositon: " + disposition);

    //       if (disposition) {
    //         const match = disposition.match(/filename\*=utf-8''([^;]+)/);
    //         if (match) {
    //           // filename = match[1];
    //           filename = decodeURIComponent(match[1]);
    //           console.log("decoded filename: " + filename);
    //         }
    //       }

    //       const blob = new Blob([response.data], { type: response.data.type });
    //       const objectUrl = URL.createObjectURL(blob);
    //       // this.content = objectUrl;
    //       const link = document.createElement("a");
    //       link.href = objectUrl;
    //       link.setAttribute("download", filename); // sets filename
    //       document.body.appendChild(link);
    //       link.click();

    //       // cleanup
    //       link.remove();
    //       window.URL.revokeObjectURL(objectUrl);
    //       // this.isLoading = false;
    //     })
    //     .catch(() => {
    //       // this.isLoading = false;
    //       console.error("Download failed:", error);
    //     });
    // },
    download(reg_id){
      window.location.href = `/api/registration/${reg_id}/download-data`;
    },
    getRegistrationsCount() {
      const url = "/api/registrations-count";
      this.$axios.get(url).then((response) => {
        this.registrationsCount = response.data.count;
        // console.log("reg count " + this.registrationsCount)
      });
    },
    bulkDownload(start_id, end_id) {
      let start = parseInt(start_id);
      let end = parseInt(end_id);
      for (let i = start; i < end + 1; i++) {
        // console.log("nice" + i);
        this.download(i);
      }
    },
    downloadRegistrationAllCSV() {
      const regAllUrl = `/api/registration/download-reg-all`;
      this.$axios
        .get(regAllUrl, {
          responseType: "blob",
        })
        .then((response) => {
          // console.log("response headers " + JSON.stringify(response.headers));
          let filename = "registrations_all.csv"; // fallback
          const disposition = response.headers["content-disposition"];
          // console.log("dispositon: " + disposition);

          if (disposition) {
            const match = disposition.match(/filename\*=utf-8''([^;]+)/);
            if (match) {
              // filename = match[1];
              filename = decodeURIComponent(match[1]);
              console.log("decoded filename: " + filename);
            }
          }

          const blob = new Blob([response.data], { type: response.data.type });
          const objectUrl = URL.createObjectURL(blob);
          // this.content = objectUrl;
          const link = document.createElement("a");
          link.href = objectUrl;
          link.setAttribute("download", filename); // sets filename
          document.body.appendChild(link);
          link.click();

          // cleanup
          link.remove();
          window.URL.revokeObjectURL(objectUrl);
        });
    },
  },
};
</script>
